import styled from "styled-components";
import MUIButton, { ButtonProps } from "@mui/material/Button";

import { breakpoints } from "@/styles/breakpoints";

interface ButtonMenuProps extends ButtonProps {
    $active?: boolean;
}

const ButtonMenu = styled(MUIButton)<ButtonMenuProps>`
    background-color: transparent;
    padding: 6px 10px;
    font-size: var(--size-16);
    border-radius: 0;
    box-shadow: none;
    border-color: transparent;
    transition: all ease-in-out 0.2s;
    position: relative;
    text-transform: unset;
    height: 100%;

    &:hover {
        background-color: transparent;
        box-shadow: none;
    }

    &::after {
        content: "";
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 0;
        height: ${(props) => (props.$active ? "2px" : 0)};
        background-color: var(--color-tertiary);
        transition: all ease-in-out 0.2s;
    }

    &.active::after,
    &:hover::after {
        height: 3px;
    }

    @media ${breakpoints.xs} {
        font-size: var(--size-14);
    }
`;

export default ButtonMenu;
